import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import CustomerReviews from "./component";
import { getCustomerReviews } from "./actions";

const mapStateToProps = ({
    customerReviews: { isSSR, list, average, total, isFetched}
}) => ({
    isSSR,
    list,
    average,
    total,
    isFetched
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getCustomerReviewsConnect: getCustomerReviews
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerReviews));
